import { styled } from 'styled-components';

const StyledPromptContainer = styled.div`
  min-height: 76px;
  background-color: #fff;
  border-top: 1px solid #CBC9C9;
  box-sizing: border-box;
  padding: 18px 0;
`;

export default StyledPromptContainer;
